"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitter = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function () {
  return {
    root: {
      width: '10px',
      height: '10px'
    }
  };
});

var Twitter = function Twitter(props) {
  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    viewBox: "0 0 10 10"
  }, props, {
    classes: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.92239 1.57639C5.14165 1.91351 4.62599 2.67313 4.60082 3.52317L4.60002 3.60301L4.49316 3.59371C3.38781 3.47984 2.3752 2.89321 1.72736 1.97072C1.54869 1.7163 1.16077 1.75405 1.0345 2.03815C0.982388 2.1554 0.909044 2.3553 0.836882 2.6206C0.598327 3.49764 0.556589 4.42112 0.842538 5.29989L0.880838 5.41166C1.16071 6.18864 1.68809 6.85116 2.4864 7.36401L2.56522 7.41341L2.51734 7.43581C1.92304 7.70062 1.2727 7.82705 0.615919 7.80092C0.194963 7.78418 0.0374914 8.34567 0.405764 8.55027C4.4216 10.7813 9.00002 8.34438 9.00002 3.60061L8.99731 3.4978L8.99042 3.40381L9.0381 3.35139C9.39947 2.93349 9.65731 2.43461 9.78866 1.89526C9.87611 1.53616 9.47147 1.26071 9.16946 1.47374L9.03728 1.56305C8.81415 1.70734 8.57718 1.82873 8.32999 1.92547L8.25202 1.95381L8.23971 1.9427C7.63511 1.41049 6.77747 1.24784 6.01022 1.54068L5.92239 1.57639ZM7.8422 2.6751C7.94545 2.79382 8.1087 2.84098 8.25936 2.79562L8.42167 2.74356L8.53482 2.70221C8.4583 2.80283 8.37599 2.89619 8.28715 2.98381C8.19209 3.07756 8.15007 3.21256 8.17514 3.34371C8.19141 3.42883 8.19974 3.51527 8.20002 3.60193L8.19886 3.72471C8.1328 7.18599 5.27494 9.16384 2.27584 8.43615L2.17202 8.40941L2.24723 8.38825C2.73391 8.24122 3.19869 8.02072 3.62467 7.73156C3.88426 7.55535 3.84918 7.16251 3.56248 7.03508C2.49403 6.56022 1.87409 5.88459 1.60328 5.05235L1.56313 4.91874C1.40242 4.33668 1.41292 3.71596 1.54137 3.10935L1.56202 3.01741L1.59948 3.05601C2.49482 3.94709 3.72431 4.44582 5.01039 4.41247C5.22719 4.40685 5.40002 4.22948 5.40002 4.01261V3.61261C5.39216 3.0232 5.74979 2.49638 6.29549 2.28809C6.84119 2.07981 7.45889 2.23437 7.8422 2.6751Z",
    fill: "black"
  }));
};

exports.Twitter = Twitter;